/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React, { useState, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import "primereact/resources/themes/md-light-indigo/theme.css";
import "primeicons/primeicons.css";
import "./OrganizationList.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { AppDispatch, RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import getErrorForUserPages from "../../../utils/methods/getErrorForUserPages";
import getWrapperOrganisationPermissions from "../../../utils/methods/permissionsWrapper/getWrappedPermissionsForOrgUser";
import {
  deleteOrganizationbyID,
  getOrganizationByTenantID,
} from "../../../store/Organisation/organisation-actions";
import { IErrorProps, WrapperUserPermissions } from "../../../models";
import TreeTableOrganizationData from "../../../models/apiModels/TreeTableOrganizationData";
import OrganizationDTO from "../../../models/apiModels/OrganizationDTO";
import DeleteDialog from "../../SharedComponents/DeleteDialog";
import Loader from "../../Loader/Loader";
import SuccessDialog from "../../SharedComponents/SuccessDialog";

import updateErrorList from "../../../utils/methods/updateErrorList";
import getOrganizationKeyByOrgId from "../../../utils/methods/getOrganizationKeyByOrgId";
import getAllParentKeys from "../../../utils/methods/getAllParentKeys";
import { organizationActions } from "../../../store/Organisation/organisation-slice";
import UserPermissions from "../../../models/apiModels/UserPermissions";
import ToastBarForError from "../../SharedComponents/ToastBarForError";
import Title from "../../SharedComponents/Title/Title";
import {
  ImportIcon,
  Button as ForgeCommonButton,
  RefreshIcon,
  SearchIcon,
  Input,
  Card,
} from "@forge/common";
import { serverErrorClose } from "../../SharedComponents/serverErrorClose";
import { setErrorPopupsusingErrorCode } from "../../TenantUser/setErrorPopupsusingErrorCode";
import ErrorHandlingComponent from "../../SharedComponents/ErrorHandlingComponent";
import GetTokenValues from "../../../utils/methods/GetTokenValues";
import { userActions } from "../../../store/User/user-slice";
import { useTranslation } from "@scuf/localization";
import { localeKeyMap } from "../../../localization/keys";
import NotificationBanner from "../../SharedComponents/NotificationBanner";
import { ConfigurationVariables } from "../../../config";

const POLLING_INTERVAL = parseInt(ConfigurationVariables.POLLING_INTERVAL) || 5000;
const MAX_ATTEMPTS = 10;

const OrganizationList = () => {
  const [t] = useTranslation();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const treeTableOrganization: TreeTableOrganizationData[] = useSelector(
    (state: RootState) => state.organisation.treeTableOrganization
  );

  const userPermissions: WrapperUserPermissions = useSelector(
    (state: RootState) => state.user.userPermissions
  );

  const orgionalOrganizationData: OrganizationDTO[] = useSelector(
    (state: RootState) => state.organisation.availableOrganization
  );

  const expandedKeysforEdit: TreeTableOrganizationData[] = useSelector(
    (state: RootState) => state.organisation.expandedKeys
  );
  const tokenValues = GetTokenValues();
  let accessTokenPayload =
    tokenValues !== undefined
      ? tokenValues.accessTokenPayload
      : {
          sub: "",
          ext: {
            customer: "",
            tenant_id: "",
          },
        };

  const tokenInfo = {
    customer: accessTokenPayload?.ext?.customer,
    tenant: accessTokenPayload?.ext?.tenant_id,
    userId: accessTokenPayload?.sub,
  };

  const tenantId: any = tokenInfo?.tenant ?? "";
  const [expandedKeys, setExpandedKeys] = useState<any>(expandedKeysforEdit);

  const [globalFilter, setGlobalFilter] = useState("");
  const [refreshTbale, setRefreshTbale] = useState(1);
  const [openDialog, setOpenDialog] = useState(false);
  const [successDialogOpen, setSuccessDialogOpen] = useState(false);

  // TODO: get type
  const [OrgToDelete, setOrgToDelete] = useState<any>();
  const [keyOfOrgLastDeleted, setKeyOfOrgLastDeleted] = useState<string>();
  const [orgToEdit, setOrgToEdit] = useState<TreeTableOrganizationData>();
  const [crumbs, setCrumbs] = useState([
    {
      id: "organization",
      label: t(localeKeyMap.organization),
    },
  ]);

  ///////////////Error Handling////////////////////////
  const [isLoading, setIsLoading] = useState(false);
  const toastErrors = useRef<IErrorProps[]>([]);
  const [errorListGlobal, setErrorListGlobal] = useState<Array<IErrorProps>>(
    []
  );
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const [openDialogServerError, setOpenDialogServerError] = useState(false);
  const [openToastError, setOpenToastError] = useState(false);
  const [openDialogforConflict, setopenDialogforConflict] = useState(false);

  const onDialogForServerCloseHandler = () => {
    serverErrorClose({
      errorListGlobal,
      setOpenDialogServerError,
      setErrorListGlobal,
    });
  };
  const onDialogForNOURLCloseHandler = () => {
    setOpenDialogNoURLError(false);
  };

  const handleToastBarClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToastError(false);
  };

  // istanbul ignore next
  useEffect(() => {
    setErrorPopupsusingErrorCode({
      errorListGlobal,
      setOpenDialogNoURLError,
      setOpenToastError,
      setOpenDialogServerError,
      openDialogNoURLError,
      openToastError,
      openDialogServerError,
    });
  }, [errorListGlobal]);
  const onDialogForConflictCloseHandler = () => {
    setopenDialogforConflict(false);
    navigate("/organization");
  };

  //////////////Error Handling////////////////////////

  const parentKeys = useRef<string[]>([]);
  const [lastOrgEdited, setLastOrgEdited] =
    useState<TreeTableOrganizationData>();

  // Auto-refresh polling refs
  const pollingInterval = useRef<NodeJS.Timeout | null>(null);
  const pollingStarted = useRef<boolean>(false);
  
  // Banner state for organization creation with polling
  const [showNotificationBanner, setShowNotificationBanner] = useState(false);
  const [newOrgName, setNewOrgName] = useState<string>("");
  
  const handleSuccesssConfirmationClose = () => {
    setSuccessDialogOpen(false);
    getAllOrganization();
  };
  const expandNode = (node: any, _expandedKeys: any) => {
    if (node.children && node.children.length) {
      _expandedKeys[node.key] = true;

      for (let child of node.children) {
        expandNode(child, _expandedKeys);
      }
    }
  };

  const expandAll = () => {
    let _expandedKeys = {};

    for (let node of treeTableOrganization) {
      expandNode(node, _expandedKeys);
    }

    setExpandedKeys(_expandedKeys);
  };

  useEffect(() => {
    expandAll();
  }, [treeTableOrganization]);

  useEffect(() => {
    setExpandedKeys(expandedKeysforEdit);
  }, [expandedKeysforEdit]);

  // This is passed as props
  // istanbul ignore next
  // Handle delete confirmation
  const handleDeleteConfirmation = () => {
    setOpenDialog(false);

    setIsLoading(true);
    const orgInfo = {
      tenantId: tenantId,
      organizationId: OrgToDelete.organizationId,
    };
    dispatch(deleteOrganizationbyID(orgInfo))
      .unwrap()
      .then(() => {
        setSuccessDialogOpen(true);
        //TODO: : Call api to get all orgnizations current value after delete
        // dispatch(getTreeTableOrganizationData("piappdevpsr1"))
        setKeyOfOrgLastDeleted(
          getOrganizationKeyByOrgId(
            OrgToDelete.organizationId,
            treeTableOrganization
          )
        );
        let keyOfOrgLastDeleted = getOrganizationKeyByOrgId(
          OrgToDelete.organizationId,
          treeTableOrganization
        );
        const getKeysToExpand = getAllParentKeys(keyOfOrgLastDeleted?.key);

        setOrgToDelete(undefined);
      })
      .catch((error) => {
        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };
  const deleteOrganization = (
    //event: any,
    rowData: TreeTableOrganizationData
  ) => {
    setOpenDialog(true);
    setOrgToDelete(rowData.data);
  };
  const handleClose = () => {
    setOpenDialog(false);
  };

  const getAllOrganization = () => {
    setIsLoading(true);
    const tenantInfoToBePassed = {
      tenantID: tenantId,
      userPermissions: userPermissions,
    };
    dispatch(getOrganizationByTenantID(tenantInfoToBePassed))
      .unwrap()
      .then(() => {})

      .catch((error) => {
        // let newError: IErrorProps = getErrorForUserPages(error);

        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  };
  const actionTemplate = (rowData: TreeTableOrganizationData) => {
    const wrappedPermissionSet = getWrapperOrganisationPermissions(
      rowData?.permissionSet
    );
    const isDeleteEnabled = wrappedPermissionSet?.can_delete_organisation;
    const isUpdateEnabled = wrappedPermissionSet?.can_update_organisation;

    return (
      <div className="flex flex-wrap gap-2">
        <ForgeCommonButton
          disabled={!isUpdateEnabled}
          variant={`${isUpdateEnabled ? "quiet-primary" : "quiet-secondary"}`}
          onClick={() =>
            // istanbul ignore next
            {
              setOrgToEdit(rowData);
              const organisationDetailsToEdit = {
                tenantId: tenantId,
                UserInfo: rowData,
              };
              dispatch(
                organizationActions.organisationToEdit(
                  organisationDetailsToEdit
                )
              );
              navigate(`/organization/edit`, {
                // state: { organisationDetailsToEdit },
              });
            }
          }
          aria-label={t(localeKeyMap.edit)}
        >
          {t(localeKeyMap.edit)}
        </ForgeCommonButton>
        {/* {rowData.data.user == 0 && rowData.children.length == 0 ?  ( */}
        <ForgeCommonButton
          disabled={!isDeleteEnabled}
          variant={`${isDeleteEnabled ? "quiet-primary" : "quiet-secondary"}`}
          onClick={() => {
            deleteOrganization(rowData);
          }}
          aria-label={t(localeKeyMap.delete)}
        >
          {t(localeKeyMap.delete)}
        </ForgeCommonButton>
      </div>
    );
  };
  let isEnabledClassForRowColumn = (isAdmin: boolean) => {
    if (isAdmin) {
      return "main_org_name";
    } else return "main_org_name_disabled";
  };

  const nameTemplate = (rowData: any) => {
    return (
      <span
        className={isEnabledClassForRowColumn(rowData.selectable)}
        onClick={() => {
          if (rowData.selectable) {
            const wrappedPermissions = getWrapperOrganisationPermissions(
              rowData.permissionSet
            );
            // Modify permissionSet to containg wrapped permissions instead of raw permissions from API
            const modifiedRowData = {
              ...rowData,
              permissionSet: wrappedPermissions,
            };
            orgNameClickHandler(modifiedRowData);
          }
        }}
      >
        {rowData.data?.name}
      </span>
    );
  };

  const orgNameClickHandler = (rowData: any) => {
    dispatch(userActions.setOrgUserListEmpty({}));
    
    // Store complete organization data in sessionStorage for page refresh handling
    sessionStorage.setItem('selectedOrganizationData', JSON.stringify(rowData));
    
    dispatch(
      organizationActions.organisationUsersPage({
        UserInfo: rowData,
        tenantId: tenantId,
      })
    );
    navigate("/organization-user-list");
  };

  const onFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGlobalFilter(event.target.value);
    // getSearchKey(
    //   Object.entries(treeTableOrganization)[0][1],
    //   event.target.value
    // );

    // const arrayOfObjects = parentKeys.current.map((item) => ({
    //   [item]: true,
    // }));
    // const newObj = arrayOfObjects.reduce((acc, obj) => {
    //   const key = Object.keys(obj)[0];
    //   acc[key] = true;
    //   return acc;
    // }, {});
    // setExpandedKeys(newObj);

    // const inputArray = ['0', '0-0', '0-0-1'];

    // const outputObject = Object.fromEntries(
    //   inputArray.map((element) => [element, true])
    //   );
    //   for (const [key, value] of Object.entries(outputObject)) {
    //     convertedObject[`'${key}'`] = value;
    //   }
    //   setExpandedKeys({'0': true, '0-0': true, '0-0-1': true});
    //   setRefreshTbale(2);
  };

  useEffect(() => {
    setRefreshTbale((prev) => prev + 1);
  }, [expandedKeys]);

  // const getSearchKey = (rootNode: any, targetValue: any) => {
  //   if (rootNode === null || rootNode === undefined) {
  //     return;
  //   }
  //   if (
  //     rootNode?.data?.name.toLowerCase().includes(targetValue.toLowerCase())
  //   ) {
  //     let getParentKeys = getAllParentKeys(rootNode.key);
  //     if (!parentKeys.current.includes(rootNode.key)) {
  //       parentKeys.current = [...parentKeys.current, rootNode.key];
  //     }
  //     // return rootNode.key;
  //   }

  //   if (rootNode.children === undefined) {
  //     return;
  //   }
  //   rootNode?.children?.map((x: any, index: any) => {
  //     getSearchKey(x, targetValue);
  //   });
  // };

  useEffect(() => {
    setIsLoading(true);
    const tenantInfoToBePassed = {
      tenantID: tenantId,
      userPermissions: userPermissions,
    };
    dispatch(getOrganizationByTenantID(tenantInfoToBePassed))
      .unwrap()
      .then(() => {})
      .catch((error: any) => {
        let newError: IErrorProps = getErrorForUserPages(error);

        setErrorListGlobal((prevState) =>
          updateErrorList(error, [...prevState])
        );
      })
      .finally(() => setIsLoading(false));
  }, []);

  // Simple polling cleanup
  const stopPolling = () => {
    if (pollingInterval.current) {
      clearInterval(pollingInterval.current);
      pollingInterval.current = null;
    }
    pollingStarted.current = false;
    setShowNotificationBanner(false);
    setNewOrgName("");
    // Remove URL parameter
    window.history.replaceState({}, "", window.location.pathname);
  };

  // Auto-refresh polling logic
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const shouldRefresh = searchParams.get("refreshAfterCreate") === "true";
    const orgName = searchParams.get("orgName");

    if (
      shouldRefresh &&
      orgName &&
      !pollingStarted.current &&
      tenantId &&
      userPermissions
    ) {
      pollingStarted.current = true;
      setShowNotificationBanner(true);
      setNewOrgName(orgName);
      
      let attempts = 0;

      const poll = () => {
        attempts++;

        const tenantInfo = {
          tenantID: tenantId,
          userPermissions: userPermissions,
        };

        dispatch(getOrganizationByTenantID(tenantInfo))
          .unwrap()
          .then((response: any) => {
            const matchingOrg = response?.originalData?.find(
              (org: any) => org.name === orgName
            );
            const hasActivePermissions =
              matchingOrg?.permissionSet?.result &&
              Object.values(matchingOrg.permissionSet.result).some(
                (value: any) => value === true
              );

            if (hasActivePermissions) {
              stopPolling();
            } else if (attempts >= MAX_ATTEMPTS) {
              stopPolling();
            }
          })
          .catch((error) => {
            stopPolling();
          });
      };

      // Start polling
      pollingInterval.current = setInterval(poll, POLLING_INTERVAL);
    }

    return () => stopPolling();
  }, [location.search, tenantId, userPermissions, dispatch]);

  return (
    <>
      <div style={{ display: "flex" }}>
        <Title
          title={t(localeKeyMap.organization)}
          className="p-t15 p-b15"
          buttonRequired={false}
        />
        <h6 style={{ paddingTop: "4.15vh" }}>&nbsp;</h6>
      </div>
      <Card className={`d-flex p-15  align-items-center justify-items-between`}>
        <div className="data_top_part">
          <h3 className="body-2">
            {orgionalOrganizationData?.length === 1 ? (
              <span>{t(localeKeyMap.totalOneOrganization)}</span>
            ) : (
              <span>
                {t(localeKeyMap.total)}{" "}
                {String(orgionalOrganizationData?.length)}{" "}
                {t(localeKeyMap.organizations)}
              </span>
            )}
          </h3>
        </div>
        <div className={`d-flex align-items-center spacing-g-10  p-r20`}>
          <div className="main_org_table_search">
            <span className="pi pi-search"></span>
            <Input
              id="search-org"
              type="text"
              placeholder={t(localeKeyMap.search)}
              name="Search"
              onChange={onFilter}
              value={globalFilter}
              prefix={<SearchIcon strokeWidth={2} />}
            />
          </div>
          <ForgeCommonButton
            label={t(localeKeyMap.schedule)}
            icon={<RefreshIcon strokeWidth={2} />}
            iconPosition="left"
            onClick={() => getAllOrganization()}
            size="regular"
            variant="tertiary"
            aria-label="Refresh"
          />

          <ForgeCommonButton
            variant="primary"
            disabled={!userPermissions.can_create_organisation}
            onClick={() => {
              if (userPermissions.can_create_organisation) {
                navigate(`/create-organization`, {
                  state: { tenantId: tenantId },
                });
              } else {
                const error: IErrorProps = {
                  errorCode: 403,
                  errorMessage: t(
                    localeKeyMap.noPrivilegesToCreateOrganization
                  ),
                };
                const errorListData: IErrorProps[] = [];
                errorListData.push(error);
                toastErrors.current = errorListData;
                setOpenToastError(true);
              }
            }}
            aria-label="Create New Organization"
          >
            {t(localeKeyMap.createNewOrganization)}
          </ForgeCommonButton>
        </div>
      </Card>
      
      {/* Organization Creation Banner */}
      <NotificationBanner 
        isVisible={showNotificationBanner} 
        type="warning" 
        hideIcon={false}
        titleLocaleKey="organizationCreationInProgress"
        descriptionLocaleKey="organizationCreationInProgressDescription"
      />
      
      <Card className="table-container main_org_table_wrap">
        <TreeTable
          className=""
          resizableColumns
          key={refreshTbale}
          expandedKeys={expandedKeys}
          onToggle={(e) => setExpandedKeys(e.value)}
          value={treeTableOrganization}
          tableStyle={{ minWidth: "50rem" }}
          scrollable
          filterMode="lenient"
          globalFilter={globalFilter}
        >
          <Column
            body={nameTemplate}
            field="name"
            header={<p className="menu-title-2">{t(localeKeyMap.name)}</p>}
            expander
          ></Column>
          <Column
            field="user"
            header={
              <p className="menu-title-2">{t(localeKeyMap.totalUsers)}</p>
            }
          ></Column>
          <Column
            body={actionTemplate}
            header={<p className="menu-title-2">{t(localeKeyMap.action)}</p>}
          ></Column>
        </TreeTable>
      </Card>

      {openDialog && (
        <DeleteDialog
          open={openDialog}
          title={t(localeKeyMap.delete)}
          handleClose={handleClose}
          DeleteConfirmationMessage={t(
            localeKeyMap.deleteOrganizationConfirmation
          )}
          subTitle={t(localeKeyMap.pleaseConfirm)}
          handleDeleteConfirmation={handleDeleteConfirmation}
        />
      )}
      <ErrorHandlingComponent
        openToast={openToastError}
        onCloseToast={handleToastBarClose}
        errorList={errorListGlobal.concat(toastErrors.current)}
        openServerError={openDialogServerError}
        onCloseServerError={onDialogForServerCloseHandler}
        openNoURL={openDialogNoURLError}
        onCloseNoURL={onDialogForNOURLCloseHandler}
        openDialogforConflict={openDialogforConflict}
        onCloseServerConflictError={onDialogForConflictCloseHandler}
      />
      {isLoading && <Loader />}
      {successDialogOpen && (
        <SuccessDialog
          open={successDialogOpen}
          title={t(localeKeyMap.deleteSuccessTitle)}
          SuccessConfirmationMessage={t(localeKeyMap.organizationDeleteSuccess)}
          handleClose={handleSuccesssConfirmationClose}
        />
      )}
    </>
  );
};

export default OrganizationList;
